import type { IconSvgObject } from './types';

const CornerRightDownIcon: IconSvgObject = [
  ["path", { d: "M10 15.002L15 20.002L20 15.002M15 19.002L15 7.00195C15 5.3451 13.6569 4.00195 12 4.00195L4 4.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerRightDownIcon;
